"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Types = exports.Stats = exports.PokemonShapes = exports.PokemonHabitats = exports.PokemonColors = exports.PokeathlonStats = exports.Natures = exports.GrowthRates = exports.Genders = exports.EggGroups = void 0;
var EggGroups;
(function (EggGroups) {
    EggGroups[EggGroups["MONSTER"] = 1] = "MONSTER";
    EggGroups[EggGroups["WATER1"] = 2] = "WATER1";
    EggGroups[EggGroups["BUG"] = 3] = "BUG";
    EggGroups[EggGroups["FLYING"] = 4] = "FLYING";
    EggGroups[EggGroups["GROUND"] = 5] = "GROUND";
    EggGroups[EggGroups["FAIRY"] = 6] = "FAIRY";
    EggGroups[EggGroups["PLANT"] = 7] = "PLANT";
    EggGroups[EggGroups["HUMANSHAPE"] = 8] = "HUMANSHAPE";
    EggGroups[EggGroups["WATER3"] = 9] = "WATER3";
    EggGroups[EggGroups["MINERAL"] = 10] = "MINERAL";
    EggGroups[EggGroups["INDETERMINATE"] = 11] = "INDETERMINATE";
    EggGroups[EggGroups["WATER2"] = 12] = "WATER2";
    EggGroups[EggGroups["DITTO"] = 13] = "DITTO";
    EggGroups[EggGroups["DRAGON"] = 14] = "DRAGON";
    EggGroups[EggGroups["NO_EGGS"] = 15] = "NO_EGGS";
})(EggGroups = exports.EggGroups || (exports.EggGroups = {}));
var Genders;
(function (Genders) {
    Genders[Genders["FEMALE"] = 1] = "FEMALE";
    Genders[Genders["MALE"] = 2] = "MALE";
    Genders[Genders["GENDERLESS"] = 3] = "GENDERLESS";
})(Genders = exports.Genders || (exports.Genders = {}));
var GrowthRates;
(function (GrowthRates) {
    GrowthRates[GrowthRates["SLOW"] = 1] = "SLOW";
    GrowthRates[GrowthRates["MEDIUM"] = 2] = "MEDIUM";
    GrowthRates[GrowthRates["FAST"] = 3] = "FAST";
    GrowthRates[GrowthRates["MEDIUM_SLOW"] = 4] = "MEDIUM_SLOW";
    GrowthRates[GrowthRates["SLOW_THEN_VERY_FAST"] = 5] = "SLOW_THEN_VERY_FAST";
    GrowthRates[GrowthRates["FAST_THEN_VERY_SLOW"] = 6] = "FAST_THEN_VERY_SLOW";
})(GrowthRates = exports.GrowthRates || (exports.GrowthRates = {}));
var Natures;
(function (Natures) {
    Natures[Natures["HARDY"] = 1] = "HARDY";
    Natures[Natures["BOLD"] = 2] = "BOLD";
    Natures[Natures["MODEST"] = 3] = "MODEST";
    Natures[Natures["CALM"] = 4] = "CALM";
    Natures[Natures["TIMID"] = 5] = "TIMID";
    Natures[Natures["LONELY"] = 6] = "LONELY";
    Natures[Natures["DOCILE"] = 7] = "DOCILE";
    Natures[Natures["MILD"] = 8] = "MILD";
    Natures[Natures["GENTLE"] = 9] = "GENTLE";
    Natures[Natures["HASTY"] = 10] = "HASTY";
    Natures[Natures["ADAMANT"] = 11] = "ADAMANT";
    Natures[Natures["IMPISH"] = 12] = "IMPISH";
    Natures[Natures["BASHFUL"] = 13] = "BASHFUL";
    Natures[Natures["CAREFUL"] = 14] = "CAREFUL";
    Natures[Natures["RASH"] = 15] = "RASH";
    Natures[Natures["JOLLY"] = 16] = "JOLLY";
    Natures[Natures["NAUGHTY"] = 17] = "NAUGHTY";
    Natures[Natures["LAX"] = 18] = "LAX";
    Natures[Natures["QUIRKY"] = 19] = "QUIRKY";
    Natures[Natures["NAIVE"] = 20] = "NAIVE";
    Natures[Natures["BRAVE"] = 21] = "BRAVE";
    Natures[Natures["RELAXED"] = 22] = "RELAXED";
    Natures[Natures["QUIET"] = 23] = "QUIET";
    Natures[Natures["SASSY"] = 24] = "SASSY";
    Natures[Natures["SERIOUS"] = 25] = "SERIOUS";
})(Natures = exports.Natures || (exports.Natures = {}));
var PokeathlonStats;
(function (PokeathlonStats) {
    PokeathlonStats[PokeathlonStats["SPEED"] = 1] = "SPEED";
    PokeathlonStats[PokeathlonStats["POWER"] = 2] = "POWER";
    PokeathlonStats[PokeathlonStats["SKILL"] = 3] = "SKILL";
    PokeathlonStats[PokeathlonStats["STAMINA"] = 4] = "STAMINA";
    PokeathlonStats[PokeathlonStats["JUMP"] = 5] = "JUMP";
})(PokeathlonStats = exports.PokeathlonStats || (exports.PokeathlonStats = {}));
var PokemonColors;
(function (PokemonColors) {
    PokemonColors[PokemonColors["BLACK"] = 1] = "BLACK";
    PokemonColors[PokemonColors["BLUE"] = 2] = "BLUE";
    PokemonColors[PokemonColors["BROWN"] = 3] = "BROWN";
    PokemonColors[PokemonColors["GRAY"] = 4] = "GRAY";
    PokemonColors[PokemonColors["GREEN"] = 5] = "GREEN";
    PokemonColors[PokemonColors["PINK"] = 6] = "PINK";
    PokemonColors[PokemonColors["PURPLE"] = 7] = "PURPLE";
    PokemonColors[PokemonColors["RED"] = 8] = "RED";
    PokemonColors[PokemonColors["WHITE"] = 9] = "WHITE";
    PokemonColors[PokemonColors["YELLOW"] = 10] = "YELLOW";
})(PokemonColors = exports.PokemonColors || (exports.PokemonColors = {}));
var PokemonHabitats;
(function (PokemonHabitats) {
    PokemonHabitats[PokemonHabitats["CAVE"] = 1] = "CAVE";
    PokemonHabitats[PokemonHabitats["FOREST"] = 2] = "FOREST";
    PokemonHabitats[PokemonHabitats["GRASSLAND"] = 3] = "GRASSLAND";
    PokemonHabitats[PokemonHabitats["MONTAIN"] = 4] = "MONTAIN";
    PokemonHabitats[PokemonHabitats["RARE"] = 5] = "RARE";
    PokemonHabitats[PokemonHabitats["ROUGH_TERRAIN"] = 6] = "ROUGH_TERRAIN";
    PokemonHabitats[PokemonHabitats["SEA"] = 7] = "SEA";
    PokemonHabitats[PokemonHabitats["URBAN"] = 8] = "URBAN";
    PokemonHabitats[PokemonHabitats["WATERS_EDGE"] = 9] = "WATERS_EDGE";
})(PokemonHabitats = exports.PokemonHabitats || (exports.PokemonHabitats = {}));
var PokemonShapes;
(function (PokemonShapes) {
    PokemonShapes[PokemonShapes["BALL"] = 1] = "BALL";
    PokemonShapes[PokemonShapes["SQUIGGLE"] = 2] = "SQUIGGLE";
    PokemonShapes[PokemonShapes["FISH"] = 3] = "FISH";
    PokemonShapes[PokemonShapes["ARMS"] = 4] = "ARMS";
    PokemonShapes[PokemonShapes["BLOB"] = 5] = "BLOB";
    PokemonShapes[PokemonShapes["UPRIGHT"] = 6] = "UPRIGHT";
    PokemonShapes[PokemonShapes["LEGS"] = 7] = "LEGS";
    PokemonShapes[PokemonShapes["QUADRUPED"] = 8] = "QUADRUPED";
    PokemonShapes[PokemonShapes["WINGS"] = 9] = "WINGS";
    PokemonShapes[PokemonShapes["TENTACLES"] = 10] = "TENTACLES";
    PokemonShapes[PokemonShapes["HEADS"] = 11] = "HEADS";
    PokemonShapes[PokemonShapes["HUMANOID"] = 12] = "HUMANOID";
    PokemonShapes[PokemonShapes["BUG_WINGS"] = 13] = "BUG_WINGS";
    PokemonShapes[PokemonShapes["ARMOR"] = 14] = "ARMOR";
})(PokemonShapes = exports.PokemonShapes || (exports.PokemonShapes = {}));
var Stats;
(function (Stats) {
    Stats[Stats["HP"] = 1] = "HP";
    Stats[Stats["ATTACK"] = 2] = "ATTACK";
    Stats[Stats["DEFENSE"] = 3] = "DEFENSE";
    Stats[Stats["SPECIAL_ATTACK"] = 4] = "SPECIAL_ATTACK";
    Stats[Stats["SPECIAL_DEFENSE"] = 5] = "SPECIAL_DEFENSE";
    Stats[Stats["SPEED"] = 6] = "SPEED";
    Stats[Stats["ACCURACY"] = 7] = "ACCURACY";
    Stats[Stats["EVASION"] = 8] = "EVASION";
})(Stats = exports.Stats || (exports.Stats = {}));
var Types;
(function (Types) {
    Types[Types["NORMAL"] = 1] = "NORMAL";
    Types[Types["FIGHTING"] = 2] = "FIGHTING";
    Types[Types["FLYING"] = 3] = "FLYING";
    Types[Types["POISON"] = 4] = "POISON";
    Types[Types["GROUND"] = 5] = "GROUND";
    Types[Types["ROCK"] = 6] = "ROCK";
    Types[Types["BUG"] = 7] = "BUG";
    Types[Types["GHOST"] = 8] = "GHOST";
    Types[Types["STEEL"] = 9] = "STEEL";
    Types[Types["FIRE"] = 10] = "FIRE";
    Types[Types["WATER"] = 11] = "WATER";
    Types[Types["GRASS"] = 12] = "GRASS";
    Types[Types["ELECTRIC"] = 13] = "ELECTRIC";
    Types[Types["PSYCHIC"] = 14] = "PSYCHIC";
    Types[Types["ICE"] = 15] = "ICE";
    Types[Types["DRAGON"] = 16] = "DRAGON";
    Types[Types["DARK"] = 17] = "DARK";
    Types[Types["FAIRY"] = 18] = "FAIRY";
    Types[Types["UNKNOWN"] = 10001] = "UNKNOWN";
    Types[Types["SHADOW"] = 10002] = "SHADOW";
})(Types = exports.Types || (exports.Types = {}));
